import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { NoAuthGuard } from './core/auth/guards/noAuth.guard';
import { Error404Component } from './shared/error-404.component';
import { Error500Component } from './shared/error-500.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'warmup',
    },

    // Redirect signed in user to the '/example'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    // { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

    // | Auth routes for guests
    {
        path: 'auth',
        component: LayoutComponent,
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'reset-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/forgot-password/forgot-password.module'
                    ).then((m) => m.AuthForgotPasswordModule),
                data: {title: 'Forgot Password'}
            },
            {
                path: 'signin',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.module').then(
                        (m) => m.AuthSignInModule
                    ),
                data: {title: 'Signin'}
            },
            {
                path: 'signup',
                loadChildren: () =>
                    import('app/modules/auth/sign-up/sign-up.module').then(
                        (m) => m.AuthSignUpModule
                    ),
                data: {title: 'Signup'}
            },
            {
                path: 'verify',
                loadChildren: () =>
                    import(
                        'app/modules/auth/verify-user/verify-user.module'
                    ).then((m) => m.VerifyUserModule),
                data: {title: 'Verify'}
            },
            {
                path: 'set-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/set-password/set-password.module'
                    ).then((m) => m.SetPasswordModule),
                data: {title: 'Set Password'}
            },
        ],
    },

    // | Auth routes for authenticated users
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.module').then(
                        (m) => m.AuthSignOutModule
                    ),
            },
        ],
    },

    // | Admin routes
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            {
                path: 'warmup',
                loadChildren: () =>
                    import('app/modules/admin/warm-up/warm-up.module').then(
                        (m) => m.WarmUpModule
                    ),
            },
            {
                path: 'manage',
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import(
                                'app/modules/admin/manage/manage.module'
                            ).then((m) => m.ManageModule),
                    },
                ],
            },
        ],
    },

    { path: '404', component: Error404Component },
    { path: '500', component: Error500Component },
    { path: '**', redirectTo: '/warmup' },
];
